import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    FQDetails: {},
}

const FQSlice = createSlice({
    name: "FQSlice",
    initialState,

    reducers: {
        FQData(state, action) {
            return {
                FQDetails: action.payload.FQDetails,
            };
        }
    }
})
export const { FQData } = FQSlice.actions;
export default FQSlice.reducer;